import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import PromotionMessage from 'yoda-core-components/lib/assets/svg/PromotionMessage.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const propTypes = {
    promotions: PropTypes.array.isRequired,
};

/* istanbul ignore next */
const PromotionalMessage = ({ promotions }) => (
    <div>
        {promotions.map((promotion) => (
            <p data-automation-id="at-price-promotions-label">
                <span className={dt(['pr-[5px]'])}>
                    <Icon
                        iconType="svg"
                        className={dt(['fill-brand-red'])}
                        width="16px"
                        height="16px"
                        viewBox="0 2 40 40"
                    >
                        <PromotionMessage />
                    </Icon>
                </span>
                <span
                    className={dt([
                        'font-semibold',
                        'italic',
                        'text-sm',
                        'leading-[1.43]',
                        'text-brand-red',
                    ])}
                >
                    {promotion.message}
                </span>
            </p>
        ))}
    </div>
);

PromotionalMessage.propTypes = propTypes;

export default PromotionalMessage;
